import { render, staticRenderFns } from "./PasswordResetEmail.vue?vue&type=template&id=50d89566&scoped=true&"
import script from "./PasswordResetEmail.vue?vue&type=script&lang=js&"
export * from "./PasswordResetEmail.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetEmail.vue?vue&type=style&index=0&id=50d89566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d89566",
  null
  
)

export default component.exports